export const createDataTestAttr = (value: string): string => {
  return value
    .toLowerCase()
    .replace(/\b\w/g, function (letter, index) {
      return index === 0 ? letter : letter.toUpperCase();
    })
    .replace(/\s+|[#]/g, "");
};
